export default "__VITE_ASSET__BoaoNeIt__"